var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found--container"},[_c('div',[_c('h1',{staticStyle:{"font-size":"98px"}},[_vm._v("404")])]),_c('div',[_vm._v(" Запрашиваемая страница не найдена ")])])])
}]

export { render, staticRenderFns }